import {
  DigitalDataEvent,
  MetricsTrackerConfigurationType,
} from '../types/types';

export default function dataAnalyticsMetricsSubscriber(
  digitalDataEvent: DigitalDataEvent,
  metricsTrackerConfig: MetricsTrackerConfigurationType
) {
  const eventData = JSON.parse(JSON.stringify(digitalDataEvent.data));
  // If the user doesn't want the event to be consumed for analytics, just return.
  if (eventData.disableDA === true) {
    return;
  }
  const { dataAnalyticsAPIPath, legacyWeb } = metricsTrackerConfig;
  const eventMeta = {
    ui_event: '',
    ui_goal: '',
    url: '',
    origin: '',
    legacy_web: legacyWeb,
  };

  // Validate required parameters for data analytics.
  if (!eventData.actionType || !eventData.actionFlow) {
    throw new Error(
      'Incomplete data analytics tracking parameters - actionType and actionFlow are required parameters'
    );
  }
  eventMeta.ui_event = eventData.actionType;
  eventMeta.ui_goal = eventData.actionFlow;
  eventMeta.url = window.location.href;
  eventMeta.origin = eventData.origin || 'user';
  delete eventData.actionType;
  delete eventData.actionFlow;
  delete eventData.origin;
  // FUTURE: The listener should implement experiments metrics.

  // Send the event to the data analytics api
  if (dataAnalyticsAPIPath) {
    fetch(dataAnalyticsAPIPath, {
      method: 'POST',
      cache: 'no-cache',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
      body: JSON.stringify({ data: eventData, meta: eventMeta }),
    });
  }
}
